import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import { addBookmarkDispatchers as dispatchSelector } from 'reduxModules/player/dispatchers'

import '../../generic/RenderedField/styles.css'
import './styles.css'

function AddBookmark({ onSubmit, hideCreateBookmark }) {
  const { register, handleSubmit } = useForm()

  useEffect(() => {
    const inputFieldComponent = document.getElementById('bookmarkName')
    if (inputFieldComponent) inputFieldComponent.select()
  }, [])

  return (
    <div id="AddBookmark">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-container">
          <i className="icon icon-bookmark-empty" />
          <div className="field -floating">
            <div className="field-container">
              <input
                {...register('bookmarkName')}
                type="text"
                placeholder=" "
                autoFocus
                id="bookmarkName"
              />
              <label htmlFor="bookmarkName">Bookmark name</label>
            </div>
          </div>
        </div>
        <div className="cta-container">
          <button
            className="close"
            onClick={() => hideCreateBookmark()}
            type="button"
          >
            Cancel
          </button>
          <button className="btn -mini -blue-2 submit-btn" type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  )
}

AddBookmark.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideCreateBookmark: PropTypes.func.isRequired
}

export default connect(null, dispatchSelector)(AddBookmark)
